import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { AppState } from 'src/app/@store/app.reducers';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';
import { ConsultaConveniosOutput, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { NgClass } from '@angular/common';
import { ListaPolizasAgentesConveniosComponent } from '../../@components/lista-polizas-agentes-convenios/lista-polizas-agentes-convenios.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-modal-ver-convenios',
    templateUrl: './modal-ver-convenios.component.html',
    styleUrls: ['./modal-ver-convenios.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCardContent, NgClass, ListaPolizasAgentesConveniosComponent, MatCardActions, MatButton]
})
export class ModalVerConveniosComponent {

  public datosConvenios = [];
  public siniestro: string;
  constructor(
    public dialogRef: MatDialogRef<ModalVerConveniosComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    @Inject(MAT_DIALOG_DATA) public data: { siniestro: SiniestroDet },
  ) {
    this.consultaConvenios();
    this.siniestro = `${this.data.siniestro.monedak}-${this.data.siniestro.ramok}-${this.data.siniestro.sramok}-${this.data.siniestro.oficinak}-${this.data.siniestro.conseck}-${this.data.siniestro.aak}`;
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  consultaConvenios() {
    const request = {
      sucursal: this.data.siniestro.sucursalk1,
      linea: this.data.siniestro.cve_linea,
      producto: this.data.siniestro.cve_prod,
      poliza: this.data.siniestro.polizak1,
      endoso: this.data.siniestro.endosok1,
      a_emision: this.data.siniestro.a_emisionk,
      no_reexpedicion: this.data.siniestro.no_reexpedicionk,
      agente: this.data.siniestro.agente,
    };
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaConvenios(request).subscribe({
      next: (value: ResultApiResponse<ConsultaConveniosOutput>) => {
        if (value.Resultado.Convenios.length) {
          this.datosConvenios = value.Resultado.Convenios.map((con, consecutivo) => ({ ...con, consecutivo, contenido: con.contenido.map((convenios, index) => ({ consecutivo: index + 1, ...convenios })) }));
        }
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de los convenios.' }));
      },
    })
  }


}
